export const hamburgerMenu = () => {
  const btn = document.querySelector(".js-hamburger-btn");
  const menu = document.querySelector(".js-hamburger-menu");
  const closeBtns = document.querySelectorAll(".js-hamburger-close");

  btn.addEventListener("click", () => {
    menu.classList.toggle("is-active");
    document.body.classList.toggle("is-hamburger-menu-open");
  });

  closeBtns.forEach((closeBtn) => {
    closeBtn.addEventListener("click", () => {
      menu.classList.remove("is-active");
      document.body.classList.remove("is-hamburger-menu-open");
    });
  });
};
